import React from "react";
import { IoIosLock } from "react-icons/io";
import PoweredByStripe from "../svgs/PoweredByStripe";
import { FaCcVisa } from "react-icons/fa";
import { FaCcMastercard } from "react-icons/fa6";
import { LiaCcAmex } from "react-icons/lia";
import { FaCcJcb } from "react-icons/fa";
import { FaCcDiscover } from "react-icons/fa";
import { FaCcDinersClub } from "react-icons/fa";

const StripeTrust = () => {
  return (
    <div
      style={{
        backgroundColor: "#F0F2F5",
        padding: "1rem",
        paddingBottom: "1rem",
        borderRadius: "0.5rem",
        marginBottom: "1.5rem",
        // maxWidth: "23rem",
        margin: "auto",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "0.5rem",
          //   flexWrap: "wrap",
          marginBottom: "1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "0.5rem",
          }}
        >
          <IoIosLock style={{ fontSize: "1.5rem", color: "#e8632b" }} />
          <div
            style={{
              fontWeight: "500",
            }}
          >
            Safe & Secure
          </div>
        </div>

        <PoweredByStripe />
      </div>
      <div
        style={{
          height: "1px",
          backgroundColor: "black",
          width: "100%",
        }}
      ></div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "0.5rem",
          marginTop: "1rem",
        }}
      >
        <FaCcVisa style={{ fontSize: "2rem" }} />
        <FaCcMastercard style={{ fontSize: "2rem" }} />
        <LiaCcAmex style={{ fontSize: "2.4rem" }} />
        <FaCcJcb style={{ fontSize: "2rem" }} />
        <FaCcDiscover style={{ fontSize: "2rem" }} />
        <FaCcDinersClub style={{ fontSize: "2rem" }} />
      </div>
    </div>
  );
};

export default StripeTrust;
